<div class="company-cases-page container-fluid">
  <div
    class="company-cases-shell d-flex flex-column mx-auto position-relative"
  >
    <blocking-loader-overlay
      :show="page_loading"
      :message="page_loading_message"
      :detail="page_loading_detail"
    />
    <section class="company-cases-header">
      <div class="company-cases-hero">
        <div class="row g-2 align-items-start">
          <div class="col-12">
            <div class="company-cases-breadcrumb text-uppercase d-flex align-items-center gap-2">
              <span>Home</span>
              <span>/</span>
              <span>Panel Register</span>
            </div>
            <h1 class="company-cases-title">
              Panel Register
            </h1>
          </div>
        </div>
      </div>

      <section class="row g-3 company-cases-metrics">
          <div v-for="metric in metrics" :key="metric.label" class="col-12 col-md-6 col-xl-3 mb-2">
            <article class="company-cases-metric h-100 shadow">
              <div class="company-cases-metric-label text-uppercase">{{ metric.label }}</div>
              <div class="company-cases-metric-value">{{ metric.value }}</div>
              <div class="company-cases-metric-change" :class="metric.change_class">{{ metric.change }}</div>
            </article>
          </div>
        </section>
    </section>

    <section class="company-cases-list">
      <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
        <h2 class="company-cases-section-title mb-0">Panel members</h2>
        <button
          type="button"
          class="btn btn-sm btn-primary-dark"
          data-bs-toggle="modal"
          data-bs-target="#create_panel_member_modal"
          @click="open_create_panel_member_modal"
        >
          Add Panel Member
        </button>
      </div>

      <div class="company-cases-filters d-flex flex-wrap gap-2">
            <button
              v-for="filter in filters"
              :key="filter.key"
              type="button"
              class="company-cases-filter shadow-sm"
              :class="{ 'is-active': active_filter === filter.key }"
              @click="set_filter(filter.key)"
            >
              {{ filter.label }}
            </button>
      </div>

      <div class="company-cases-table-wrap shadow">
        <div class="table-responsive">
              <table class="table company-cases-table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Panel Member</th>
                    <th>Role . Scope</th>
                    <th>Caseload</th>
                    <th>SLA</th>
                    <th>Specialism</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(member, index) in paginated_members" :key="member.code">
                    <td class="px-4 py-3">
                      <div class="d-flex align-items-center gap-3">
                        <span
                          class="avatar-circle text-white fw-bold flex-shrink-0"
                          :class="index % 3 === 2 ? 'bg-warning' : 'bg-primary'"
                        >
                          {{ member.initials }}
                        </span>
                        <div>
                          <div class="company-case-title">{{ member.name }}</div>
                          <div class="company-case-subtitle">{{ member.code }} - accredited {{ member.accredited }}</div>
                        </div>
                      </div>
                    </td>
                    <td class="px-4 py-3">
                      <div class="company-case-owner fw-semibold">{{ member.role }}</div>
                      <div v-if="member.scope" class="company-case-subtitle">{{ member.scope }}</div>
                    </td>
                    <td class="px-4 py-3">
                      <div class="company-cases-metric-value">{{ member.caseload }}</div>
                      <div class="company-case-subtitle">{{ member.caseload_meta }}</div>
                    </td>
                    <td class="px-4 py-3">
                      <span class="company-case-sla p-2 rounded-small" :class="member.sla_badge_class">
                        {{ member.sla }}
                      </span>
                    </td>
                    <td class="px-4 py-3">
                      <div class="company-case-owner">{{ member.specialism }}</div>
                    </td>
                    <td class="px-4 py-3">
                      <div class="company-case-status d-flex align-items-center gap-2">
                        <span class="d-flex align-items-center gap-2">
                          <span
                            class="status-dot-sm rounded-circle d-inline-block"
                            :class="member.status === 'Available' ? 'bg-primary' : 'bg-warning'"
                          ></span>
                          <span>{{ member.status }}</span>
                        </span>
                        
                      </div>
                    </td>
                    <td colspan="3" class="text-center text-secondary small">
                      <button
                          type="button"
                          class="btn btn-sm btn-primary-dark"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_panel_member_modal"
                          @click="open_edit_panel_member_modal(member)"
                        >
                          Edit
                        </button>
                    </td>
                  </tr>
                  <tr v-if="!page_loading && !filtered_members.length">
                    <td colspan="6" class="px-4 py-4 text-center text-secondary small">No panel members match this filter.</td>
                  </tr>
                </tbody>
              </table>
        </div>
      </div>

      <div
        v-if="!page_loading && filtered_members.length"
        class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 px-2 py-3"
      >
        <div class="text-secondary text-xs">
          Showing {{ pagination_label }}
        </div>

        <nav aria-label="Panel members pagination">
          <div class="d-inline-flex align-items-center rounded-3 border overflow-hidden bg-white">
            <button
              type="button"
              class="btn btn-sm btn-light border-0 rounded-0 px-2"
              @click="set_page(current_page - 1)"
              :disabled="current_page === 1"
              aria-label="Previous page"
            >
              <i class="bi bi-chevron-left"></i>
            </button>

            <button
              v-for="page in total_pages"
              :key="page"
              type="button"
              class="btn btn-sm rounded-0 border-0 border-start px-3 pagination-seg-btn"
              :class="page === current_page ? 'btn-primary-dark text-white' : 'btn-light'"
              @click="set_page(page)"
            >
              {{ page }}
            </button>

            <button
              type="button"
              class="btn btn-sm btn-light border-0 border-start rounded-0 px-2"
              @click="set_page(current_page + 1)"
              :disabled="current_page === total_pages"
              aria-label="Next page"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </nav>
      </div>
    </section>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="create_panel_member_modal"
      tabindex="-1"
      aria-labelledby="create_panel_member_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0" id="create_panel_member_modal_label">
              Add Panel Member
            </p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="panel_member_first_name" class="modal-form-label form-label text-xxs">First Name:</label>
              <input
                id="panel_member_first_name"
                v-model="create_form.first_name"
                type="text"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Enter First Name Here"
                minlength="2"
                maxlength="50"
                required
                @input="sanitize_panel_name_field('create_form', 'first_name')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="panel_member_last_name" class="modal-form-label form-label text-xs">Last Name:</label>
              <input
                id="panel_member_last_name"
                v-model="create_form.last_name"
                type="text"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Enter Last Name Here"
                minlength="2"
                maxlength="50"
                required
                @input="sanitize_panel_name_field('create_form', 'last_name')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="panel_member_email" class="modal-form-label form-label text-xs">Email:</label>
              <input
                id="panel_member_email"
                v-model="create_form.email"
                type="email"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Enter Email Address Here"
                required
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="panel_member_phone_number" class="modal-form-label form-label text-xs">Phone Number:</label>
              <input
                id="panel_member_phone_number"
                v-model="create_form.phone_number"
                type="tel"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Enter Phone Number Here"
                minlength="10"
                maxlength="10"
                pattern="[0-9]{10}"
                required
                @input="sanitize_panel_phone_field('create_form')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="panel_member_role" class="modal-form-label form-label text-xs">Role:</label>
              <select
                id="panel_member_role"
                v-model="create_form.role"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                :disabled="roles_loading"
                @change="handle_create_role_change"
              >
                <option value="" disabled hidden>
                  {{ roles_loading ? 'Loading Roles...' : 'Select Role' }}
                </option>
                <option v-for="role in roles" :key="role.id" :value="role.role">
                  {{ role.role }}
                </option>
              </select>
            </div>

            <div v-if="!create_form_is_system_admin" class="modal-form-group form-group mb-3">
              <label for="panel_member_region" class="modal-form-label form-label text-xs">Region:</label>
              <select
                id="panel_member_region"
                v-model="create_form.role_group_id"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                :disabled="roles_loading"
              >
                <option value="" disabled hidden>
                  {{ roles_loading ? 'Loading Regions...' : 'Select Region' }}
                </option>
                <option v-for="group in role_groups" :key="group.id" :value="String(group.id)">
                  {{ group.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2"
              :disabled="creating_member"
              @click="create_panel_member"
            >
              <span
                v-if="creating_member"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="edit_panel_member_modal"
      tabindex="-1"
      aria-labelledby="edit_panel_member_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0" id="edit_panel_member_modal_label">
              Edit Panel Member
            </p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="edit_panel_member_first_name" class="modal-form-label form-label text-xs">First Name:</label>
              <input
                id="edit_panel_member_first_name"
                v-model="edit_form.first_name"
                type="text"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Enter First Name Here"
                minlength="2"
                maxlength="50"
                required
                @input="sanitize_panel_name_field('edit_form', 'first_name')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_panel_member_last_name" class="modal-form-label form-label text-xs">Last Name:</label>
              <input
                id="edit_panel_member_last_name"
                v-model="edit_form.last_name"
                type="text"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Enter Last Name Here"
                minlength="2"
                maxlength="50"
                required
                @input="sanitize_panel_name_field('edit_form', 'last_name')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_panel_member_email" class="modal-form-label form-label text-xs">Email:</label>
              <input
                id="edit_panel_member_email"
                v-model="edit_form.email"
                type="email"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Enter Email Address Here"
                required
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_panel_member_phone_number" class="modal-form-label form-label text-xs">Phone Number:</label>
              <input
                id="edit_panel_member_phone_number"
                v-model="edit_form.phone_number"
                type="tel"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Enter Phone Number Here"
                minlength="10"
                maxlength="10"
                pattern="[0-9]{10}"
                required
                @input="sanitize_panel_phone_field('edit_form')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_panel_member_role" class="modal-form-label form-label text-xs">Role:</label>
              <select
                id="edit_panel_member_role"
                v-model="edit_form.role_id"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                :disabled="roles_loading"
                @change="handle_edit_role_change"
              >
                <option value="" disabled hidden>
                  {{ roles_loading ? 'Loading Roles...' : 'Select Role' }}
                </option>
                <option v-for="role in roles" :key="role.id" :value="role.id">
                  {{ role.role }}
                </option>
              </select>
            </div>

            <div v-if="!edit_form_is_system_admin" class="modal-form-group form-group mb-3">
              <label for="edit_panel_member_region" class="modal-form-label form-label text-xs">Region:</label>
              <select
                id="edit_panel_member_region"
                v-model="edit_form.role_group_id"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                :disabled="roles_loading"
              >
                <option value="" disabled hidden>
                  {{ roles_loading ? 'Loading Regions...' : 'Select Region' }}
                </option>
                <option v-for="group in role_groups" :key="group.id" :value="String(group.id)">
                  {{ group.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2"
              :disabled="updating_member"
              @click="update_panel_member"
            >
              <span
                v-if="updating_member"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
